'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = parseQueryString;
function parseQueryString(query) {
    query = query || window.location.search || window.location.hash;

    return query.replace(/^.*\?/, '').split('&').map(function (pair) {
        return pair.split('=');
    }).reduce(function (obj, pair) {
        var key = pair.shift();
        if (key.trim()) {
            obj[key] = pair.join('=');
        }

        return obj;
    }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/@guazi-fe/components/build/client/utils/parseQueryString.js
// module id = 1458
// module chunks = 1